export default __webpack_public_path__ + "images/0B.c7a87c0.png";